import React from "react"
import "./src/styles/global.css"

import RootLayout from "./src/components/RootLayout"


/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const wrapRootElement = ({ element }) => {
  return <RootLayout>{element}</RootLayout>
}
